<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="force-posting-modal" @click.stop>
                    <div
                        v-if="success"
                        class="force-posting-content force-posting-success-content"
                    >
                        <div class="force-posting-success-icon">
                            <span class="force-posting-success-check"></span>
                        </div>

                        <h2 class="force-posting-success-title">Berhasil Force Posting TO</h2>

                        <button
                            class="btn force-posting-ok"
                            type="button"
                            @click="$emit('closeModal')"
                        >
                            OK
                        </button>
                    </div>

                    <div v-else class="force-posting-content">
                        <div class="force-posting-icon">
                            <span class="force-posting-icon-line"></span>
                            <span class="force-posting-icon-dot"></span>
                        </div>

                        <h2>{{ title }}</h2>
                        <p class="force-posting-desc">
                            Anda akan melakukan force posting
                            <br>
                            No TO : <strong>{{ noReferensi }}</strong>
                            <br>
                            NOPOL : <strong>{{ data.nopol }}</strong>
                            <br>
                            Tanggal : <strong>{{ data.tanggal_dokumen }}</strong>
                        </p>

                        <div class="force-posting-warning">
                            <span class="force-posting-warning-icon">
                                <i class="fas fa-exclamation-triangle"></i>
                            </span>
                            <p>Tindakan ini akan memaksa status menjadi Posting tanpa konfirmasi dari driver.</p>
                        </div>

                        <div class="force-posting-actions">
                            <button
                                class="btn force-posting-cancel"
                                type="button"
                                :disabled="loading"
                                @click="$emit('closeModal')"
                            >
                                Batal
                            </button>
                            <button
                                class="btn force-posting-confirm"
                                type="button"
                                :disabled="loading"
                                @click="processData"
                            >
                                {{ loading ? 'Memproses...' : 'Konfirmasi' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props : ['data', 'title'],
    data () {
        return {
            loading : false,
            success : false
        }
    },
    computed : {
        noReferensi () {
            return this.data.no_referensi || this.data.no_to
        }
    },
    methods : {
        processData () {
            this.loading = true

            this.$http.post('/api/validation/force-posting', {
                no_referensi : this.noReferensi,
                nopol : this.data.nopol
            })
            .then(() => {
                this.$emit('updateTable')
                this.success = true
            })
            .catch((err) => {
                let message = 'Force posting gagal diproses.'

                if (err.response && err.response.data) {
                    message = err.response.data.message || err.response.data.error || message
                }

                this.$swal.fire({
                    title : 'Error',
                    text : message,
                    icon : 'error'
                })
            })
            .finally(() => {
                this.loading = false
            })
        }
    }
}
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .36);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .force-posting-modal {
        width: 557px;
        max-width: calc(100vw - 32px);
        margin: 0 auto;
        background-color: #FFFFFF;
        border-radius: 8px;
        box-shadow: none;
        font-family: Poppins, Helvetica, Arial, sans-serif;
        transition: all .3s ease;
    }

    .force-posting-content {
        padding: 57px 65px 47px;
    }

    .force-posting-success-content {
        align-items: center;
        display: flex;
        flex-direction: column;
        min-height: 409px;
        padding: 61px 65px;
    }

    .force-posting-icon {
        align-items: center;
        border: 7px solid #F9BF4B;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        height: 109px;
        justify-content: center;
        margin: 0 auto 24px;
        width: 109px;
    }

    .force-posting-icon-line {
        background-color: #F9BF4B;
        display: block;
        height: 43px;
        margin-bottom: 11px;
        width: 7px;
    }

    .force-posting-icon-dot {
        background-color: #F9BF4B;
        border-radius: 50%;
        display: block;
        height: 12px;
        width: 12px;
    }

    .force-posting-modal h2 {
        color: #343434;
        font: normal normal 600 28px/42px Poppins;
        margin: 0 0 17px;
        text-align: center;
    }

    .force-posting-desc {
        color: #343434;
        font: normal normal normal 20px/28px Poppins;
        margin: 0 0 27px;
        text-align: center;
    }

    .force-posting-warning {
        align-items: flex-start;
        background: #FFF2DB;
        border: 1px solid #F7C982;
        border-radius: 4px;
        display: flex;
        gap: 13px;
        margin-bottom: 31px;
        min-height: 76px;
        padding: 12px 12px;
    }

    .force-posting-warning-icon {
        color: #9A4A00;
        flex: 0 0 auto;
        font-size: 14px;
        line-height: 21px;
        margin-top: 17px;
    }

    .force-posting-warning p {
        color: #884200;
        font: normal normal normal 17px/24px Poppins;
        margin: 0;
    }

    .force-posting-actions {
        display: flex;
        gap: 27px;
    }

    .force-posting-actions button {
        border-radius: 4px;
        font: normal normal normal 24px/36px Poppins;
        height: 60px;
        width: 100%;
    }

    .force-posting-cancel {
        background-color: #FFFFFF;
        border: 1px solid #1B698E;
        color: #1B698E;
    }

    .force-posting-confirm {
        background-color: #1B698E;
        color: #FFFFFF;
    }

    .force-posting-success-icon {
        align-items: center;
        border: 7px solid #2ECC8A;
        border-radius: 50%;
        display: flex;
        height: 131px;
        justify-content: center;
        margin: 0 auto 21px;
        width: 131px;
    }

    .force-posting-success-check {
        border-bottom: 7px solid #2ECC8A;
        border-left: 7px solid #2ECC8A;
        display: block;
        height: 29px;
        margin-top: -12px;
        transform: rotate(-45deg);
        width: 58px;
    }

    .force-posting-modal .force-posting-success-title {
        color: #343434;
        font: normal normal 600 28px/42px Poppins;
        margin: 0 0 35px;
        text-align: center;
    }

    .force-posting-ok {
        background-color: #1B698E;
        border-radius: 6px;
        color: #FFFFFF;
        font: normal normal normal 24px/36px Poppins;
        height: 60px;
        width: 170px;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .force-posting-modal,
    .modal-leave-active .force-posting-modal {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    @media (max-width: 575px) {
        .force-posting-content {
            padding: 36px 24px 32px;
        }

        .force-posting-modal h2 {
            font-size: 24px;
            line-height: 34px;
        }

        .force-posting-desc {
            font-size: 16px;
            line-height: 24px;
        }

        .force-posting-warning p {
            font-size: 14px;
            line-height: 21px;
        }

        .force-posting-actions {
            gap: 12px;
        }

        .force-posting-actions button {
            font-size: 18px;
            line-height: 28px;
        }

        .force-posting-success-content {
            min-height: 360px;
            padding: 44px 24px;
        }

        .force-posting-success-icon {
            height: 112px;
            width: 112px;
        }

        .force-posting-modal .force-posting-success-title {
            font-size: 24px;
            line-height: 34px;
        }
    }
</style>
